// src/components/intake/IntakeRoute.jsx
import React, { useState } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import IntakePage from "./IntakePage";
import { QUESTIONS_PATH } from "./intakeNav";

// /intake/:pageKey inside <OnboardingGate stageKey="intake">: the gate sends a
// client ahead of intake to their own page (trial_start → You're in). Past
// intake the wizard is first-run only (decision 19): the Questions page.
// Keyed by page so each page starts from its own GET and its own draft.
export default function IntakeRoute({ readOnly = false }) {
  const { pageKey } = useParams();
  const location = useLocation();
  // What this visit learned about Plaid (an inline consent, a link), so the
  // next page does not ask again or open Link a second time.
  const [plaidSeen, setPlaidSeen] = useState({});
  if (readOnly) return <Navigate to={QUESTIONS_PATH} replace />;
  return (
    <IntakePage
      key={pageKey}
      pageKey={pageKey}
      focusPart={location.state?.part}
      plaidSeen={plaidSeen}
      onPlaidChange={(patch) => setPlaidSeen((s) => ({ ...s, ...patch }))}
    />
  );
}
